// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tableBox[data-v-1cfd656a]{height:calc(100% - 260px)}.colorStyle[data-v-1cfd656a]{color:red}.mdTitName[data-v-1cfd656a]{height:24px;border:1px solid #d7d7d7;text-align:center;min-width:100px}.formbox[data-v-1cfd656a] ,.headebut[data-v-1cfd656a]{width:60%;margin:0 auto}.headebut[data-v-1cfd656a]{padding-left:100px;box-sizing:border-box}", ""]);
// Exports
module.exports = exports;
